import { render, staticRenderFns } from "./usm-distribution-table.vue?vue&type=template&id=6e674ade&"
var script = {}
import style0 from "./usm-distribution-table.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports